<template>
    <div class="secondary_banner" :style="{backgroundImage:`url(${img})`}" :data-content="title">
        {{title}}
    </div>
</template>
<script>
export default {
    props:{
        title:{
            type:[String,Number],
            default:'课程微课资源库'
        },
        img:{
            type:String,
            default:require('@/assets/images/usertype/2.png')
        }
    }
}
</script>
<style lang="scss" scoped>
@font-face{
    font-family:huakang;
    src:url('~@/assets/fount/huakang.TTF');
}
.secondary_banner{
    // background: url('~@/assets/images/secound_bg.png');
    background-size: cover;
    background-position: center center;
    padding: 110px 0;
    text-align: center;
    font-family:huakang;
    font-size: 70px;
    
    color: #045923;
    /* 设置描边宽度及颜色 */
    text-stroke: 8px #fff;
    /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
    -webkit-text-stroke: 8px #fff;
    
}
/* 通过属性选择器结合伪元素before 实现文字外描边效果 */
[data-content]::before {
  /* attr()是用来获取被选中元素的某属性值,并且在样式文件中使用 */
  content: attr(data-content);
  position: absolute;
  /* 实现元素外描边的关键 */
  -webkit-text-stroke: 0;
  /* 文本颜色 */
  color: #045923;
}
</style>